import React from 'react';
import { Styles } from './styles';
import { Text } from 'atoms/Text/Text';
import SearchIcon from 'assets/svgs/searchIcon.svg';
import { defaultTheme } from 'constants/theme/defaultTheme';
import { TEST_IDS } from 'constants/testIds';

interface EmptyStateProps {
  heading: string;
  body: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ heading, body }) => (
  <Styles.Container>
    <Styles.Content>
      <Styles.SearchIconContainer>
        <SearchIcon color={defaultTheme.colors.healthBlue} width={30} height={30} />
      </Styles.SearchIconContainer>
      <Styles.HeadingContainer>
        <Text.body1
          data-testid={TEST_IDS.products.emptyState.heading}
          color={defaultTheme.colors.deepBlue}
        >
          {heading}
        </Text.body1>
      </Styles.HeadingContainer>
      <Text.caption2 color={defaultTheme.colors.darkGrey}>{body}</Text.caption2>
    </Styles.Content>
  </Styles.Container>
);
